import { setDeviceTypes } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@casops/filters/types';
import MultiselectFilter from '../multiselect/MultiselectFilter';
import { AssetDeviceType } from '@casops/store/apis/registeredAssetsApi';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

// Remove "Unknown" from the enum before making the list of devices.
const DEVICE_TYPES: AssetDeviceType[] = Object.values(AssetDeviceType).slice(1);

export const useDeviceTypeOptions = (): DropdownItemProps<AssetDeviceType>[] => {
  const { t } = useTranslation();
  return useMemo(() => {
    return DEVICE_TYPES.map((value: AssetDeviceType) => {
      return { key: value, value, stringValue: value, label: t(`AssetDeviceType.${value}`) };
    });
  }, [t]);
};

export const DeviceTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();
  return (
    <MultiselectFilter<AssetDeviceType>
      filterName="deviceTypes"
      label={label ?? t('Fields.Filters.DeviceType')}
      action={setDeviceTypes}
      elementRef={elementRef}
      useItemsHook={useDeviceTypeOptions}
    />
  );
};

export default DeviceTypesFilter;
